<shig-sf-header class="lay-wrapper lay-wrapper--header" />

<div class="lay-wrapper lay-wrapper--main" style="padding-bottom: 0; max-width: 100vw; overflow-x: hidden">
    <router-outlet #outlet="outlet" />
</div>

<shig-footer />
